import React, { useState, useEffect } from 'react';
import ComejoinCard from "./ComejoinCard";
import './Comejoin.css'
import { images } from "../../../assets";

export default function Comejoin() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let imgSrc;
  if (windowWidth <= 431) {
    imgSrc = images.comejoinBgMobile;
  } else if (windowWidth > 431 && windowWidth <= 821) {
    imgSrc = images.comejoinBgTablet; // Add the new image for tablet screens
  } else {
    imgSrc = images.comejoinBg;
  }


  const data = {
    id: 1,
    heading: "Come join our team and make an Impact!",
    desc: "Join us and be a part of a team that is making a difference!",
    img: imgSrc,
    button: "Join Us",
  };

  const customClass = {
    comejoin: "comejoin",
    comejoincomp: "comejoincomp",
    comejoincard: "comejoincard",
    comejoincontent: "comejoincontent",
    comejoinheading: "comejoinheading",
    comejoindesc: "comejoindesc",
    comejoinbutton: "comejoinbutton",
    seeoppurtunities: "seeoppurtunities",
  };

  return <ComejoinCard className={customClass} data={data} />;
}
